import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { TrendingUp, DollarSign, Users } from "lucide-react";

const metrics = [
  {
    icon: DollarSign,
    value: "$10M",
    label: "Annual Cost Savings",
    description: "Through digital self-service transformation",
  },
  {
    icon: TrendingUp,
    value: "$6M",
    label: "New Gross Revenue",
    description: "Direct-to-consumer ACA portal launch",
  },
  {
    icon: Users,
    value: "Agile",
    label: "Transformation Leader",
    description: "Enterprise-wide methodology adoption",
  },
];

export function ImpactBar() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} aria-labelledby="impact-heading" className="relative py-16 md:py-20 bg-secondary">
      <div className="container-wide">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 id="impact-heading" className="text-sm font-semibold uppercase tracking-wider text-accent mb-2">
            The Impact
          </h2>
          <p className="text-lg text-muted-foreground">
            Measurable results that drive business forward
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {metrics.map((metric, index) => (
            <motion.div
              key={metric.label}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative text-center group"
            >
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-accent/10 text-accent mb-4 group-hover:bg-accent group-hover:text-accent-foreground transition-colors duration-300">
                <metric.icon className="w-7 h-7" />
              </div>

              {/* Value */}
              <div className="text-4xl md:text-5xl font-bold text-foreground mb-2">
                {metric.value}
              </div>

              {/* Label */}
              <div className="text-lg font-semibold text-foreground mb-1">
                {metric.label}
              </div>

              {/* Description */}
              <p className="text-sm text-muted-foreground max-w-xs mx-auto">
                {metric.description}
              </p>

              {/* Divider for desktop */}
              {index < metrics.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 lg:-right-6 w-px h-24 bg-border -translate-y-1/2" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
